import React from 'react';

const ServiceCard = ({ icon, title, description, href = '#monitoring', ctaLabel = 'Learn more →' }) => {
  return (
    <div className="bg-gray-50 rounded-lg p-6 shadow-md hover:shadow-lg transition duration-300">
      <div className="text-purple-600 mb-4">
        {icon}
      </div>
      <h3 className="text-xl font-bold mb-2 text-black">{title}</h3>
      <p className="text-gray-600 mb-4">{description}</p>
      <a href={href} className="text-purple-600 font-medium hover:text-purple-800">
        {ctaLabel}
      </a>
    </div>
  );
};

export default ServiceCard;
